/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Success_Toast_ScenaristInputs */



/**
* | output |
* | --- |
* | "Successfully exported {count} images, SST script, and FCP XML" |
*
* @param {Image_Export_Success_Toast_ScenaristInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_success_toast_scenarist = /** @type {((inputs: Image_Export_Success_Toast_ScenaristInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Success_Toast_ScenaristInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation reussie de ${i?.count} images, du script SST et du XML FCP`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Bilder, SST-Skript und FCP-XML erfolgreich exportiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Immagini ${i?.count}, script SST e XML FCP esportati correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изображения ${i?.count}, скрипт SST и FCP XML успешно экспортированы.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se exportaron con exito las imagenes ${i?.count}, el script SST y el XML FCP`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功导出 ${i?.count} 图像、SST 脚本和 FCP XML`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 枚の画像、SST スクリプト、FCP XML を正常にエクスポートしました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} इमेज, SST स्क्रिप्ट और FCP XML सफलतापूर्वक निर्यात कर दी गई हैं।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Imagens ${i?.count}, script SST e XML FCP exportados com sucesso.`)
	return /** @type {LocalizedString} */ (`Successfully exported ${i?.count} images, SST script, and FCP XML`)
});